import { Card, Divider, Row, Text, Spinner } from '@nextui-org/react';
import React, { useState, useEffect } from 'react';
import dayjs from '../../../lib/day';
import { fetchWithJson } from "../../../lib/api";
import { error } from "../../../lib/userAlerts";
import endpoint from "../../../config/endpoint.json";

const IntegrationStats = ({ clientId }) => {
    const [stats, setStats] = useState({
        integrationTime: 'N/A',
        integrationRecs: 0,
        loading: true
    });

    useEffect(() => {
        if (clientId) {
            fetchData(clientId);
        }
    }, [clientId]);

    const fetchData = async (clientId) => {
        try {
            setStats(prev => ({ ...prev, loading: true }));
            const res = await fetchWithJson(endpoint.statsIntegration, {
                company_id: clientId,
            });

            if (res.status !== 200) {
                error('Unable to fetch integration stats');
                setStats(prev => ({ ...prev, loading: false }));
                return;
            }

            const data = await res.json();
            setStats({
                integrationTime: data?.integration?.runTime 
                    ? dayjs.unix(data.integration.runTime).fromNow()
                    : 'N/A',
                integrationRecs: data?.integration?.numRecords || 0,
                loading: false
            });
        } catch (err) {
            console.error(err);
            error('Unable to fetch integration stats');
            setStats(prev => ({ ...prev, loading: false }));
        }
    };

    const StatRow = ({ label, value }) => (
        <Row justify="space-between" align="center" className="py-2">
            <Text size={16} color="$gray600">{label}</Text>
            <Text size={16} weight="semibold" color="$gray900">{value}</Text>
        </Row>
    );

    return (
        <Card 
            css={{ 
                br: 0,
                minWidth: '300px',
                transition: 'all 0.2s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '$lg'
                }
            }}
            bordered 
            shadow={false}
        >
            <Card.Header className="px-6 py-4">
                <Text size={20} weight="semibold" color="$gray900">
                    Shipment API
                </Text>
            </Card.Header>
            
            <Divider />
            
            <Card.Body css={{ br: 0, px: '$6', py: '$4' }}>
                {stats.loading ? (
                    <div className="flex justify-center items-center py-4">
                        <Spinner size="sm" color="primary" />
                    </div>
                ) : (
                    <>
                        <StatRow 
                            label="Shipment data last updated" 
                            value={stats.integrationTime} 
                        />
                        <StatRow 
                            label="Records Processed" 
                            value={stats.integrationRecs.toLocaleString()} 
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default IntegrationStats;